const GROUP_SIZE = 3
const LEFT_TO_RIGHT_ISOLATE = '\u2066'
const POP_DIRECTIONAL_ISOLATE = '\u2069'
const DIRECTIONAL_ISOLATE_REGEXP = /[\u2066\u2069]/g

export function isolatePhoneNumber(phoneNumber: string): string
export function isolatePhoneNumber(phoneNumber: string | undefined): string | undefined
export function isolatePhoneNumber(phoneNumber: string | undefined) {
  if (!phoneNumber) return phoneNumber
  if (phoneNumber.startsWith(LEFT_TO_RIGHT_ISOLATE) && phoneNumber.endsWith(POP_DIRECTIONAL_ISOLATE)) return phoneNumber
  return `${LEFT_TO_RIGHT_ISOLATE}${phoneNumber}${POP_DIRECTIONAL_ISOLATE}`
}

export function stripPhoneNumberIsolation(phoneNumber: string) {
  return phoneNumber.replace(DIRECTIONAL_ISOLATE_REGEXP, '')
}

/**
  * Format phone number (and optional prefix)
  *
  * @remarks
  * - Groups of size 3
  * - Sanitise: Remove '\s' and '+' before processing
  *
  * @param phoneNumber - input number
  * @returns Formatted phone number string
  */
export function formatPhoneNumber(phoneNumber: string, prefix?: string) {
  const sanitisedInput = phoneNumber.replace(/\s/g, '')
  const numberGroups = prefix ? [`+${prefix.replace(/\+/g, '')}`] : []

  for (let anchor = 0; anchor < sanitisedInput.length; anchor += GROUP_SIZE) {
    const group = sanitisedInput.substring(anchor, anchor + GROUP_SIZE)
    numberGroups.push(group)
  }

  return isolatePhoneNumber(numberGroups.join(' '))
}

/**
  * Remove all formatting from a phone number
  *
  * @remarks
  * - It is safe to strip the leading '0' (if it exists), national numbers never have a leading '0'
  * - Prefix is not part of this string
  *
  * @param input - input phone number
  * @returns sanitised phone number
  */
export function sanitisePhoneNumber(input: string) {
  const charsArr: Array<string> = []
  for (let i = 0; i < input.length; i++) {
    if (typeof input?.charAt != 'function') { continue }
    const char = input.charAt(i)
    if (i === 0 && char === '0') { continue }
    if (isNaN(parseInt(char))) { continue }
    charsArr.push(char)
  }
  return charsArr.join('')
}
